import type {
  ChallengesState,
  ChallengesAction
} from '@/redux/challenges/types';

import type { Reducer } from 'redux';
import { Actions } from '@/redux/challenges/actions';

export const initialState = { challenges: [] } as ChallengesState;

export default ((state = initialState, action: ChallengesAction) => {
  switch (action.type) {
    case Actions.SetChallengesData:
      return { ...state, ...action.data };

    case Actions.SetChallengesDataFail:
      return { ...state, error: action.error };

    case Actions.SetChallengeData: {
      const challenge = action.data?.challenges[0];

      return {
        ...((challenge && {
          challenges: state.challenges
            .filter(({ id }) => challenge.id !== id)
            .concat(challenge)
        }) ??
          state)
      };
    }

    case Actions.SetChallengeDataFail:
      return { ...state, error: action.error };

    default:
      return state;
  }
}) as Reducer<ChallengesState, ChallengesAction>;
